<script setup lang="ts">
const { data: artworks } = useFetch<Artwork[]>("/api/artworks");

const { data: categories } = await useFetch<ArtworkCategory[]>("/api/artwork-categories");

const isotope = ref<Isotope>();
onMounted(async () => {
  if (import.meta.client) {
    setTimeout(async () => {
      // await import("jquery");
      const Isotope = (await import("isotope-layout")).default;
      // const imagesLoaded = (await import("imagesloaded")).default;

      // @ts-ignore
      imagesLoaded(".masonry", async () => {
        /// @ts-ignore
        await nextTick();
        isotope.value = new Isotope(".masonry", {
          // main isotope options
          itemSelector: ".masonry-item",
          // set layoutMode
          layoutMode: "masonry",
          // options for cellsByRow layout mode
        });

        // setupFilters();
      });
    }, 500);
  }
});
</script>
<template>
  <div class="xboot-standard-row dark-row">
    <!-- Portfolio content -->
    <div class="container-fluid">
      <div class="portfolio-content">
        <!-- <div class="portfolio-filter-wrap text-left">
          <ul class="portfolio-filter">
            <li class="active"><a href="#" data-filter="*"> All</a></li>
            <li v-for="value in categories" :key="value.id">
              <a href="#" :data-filter="`.cat-${value.slug}`">{{
                value.title
              }}</a>
            </li>
          </ul>
        </div> -->
        <div class="masonry portfolio portfolio-gutter portfolio-style-1 portfolio-masonry portfolio-not-full portfolio-2-column">
          <CategoryArtworksGridItem v-for="(category, index) in categories" :key="index" :category="category" />
        </div>
        <!-- <div class="pagination-area">
          <div class="load-more text-center">
            <a class="button lode-more" href="#"
              >view more<i class="ti-reload"></i
            ></a>
          </div>
        </div> -->
      </div>
    </div>
    <!-- portfolio content end -->
  </div>
</template>
